"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalDateTimeField = void 0;
const react_1 = __importDefault(require("react"));
const instant_field_1 = require("../instant-field/instant-field");
function LocalDateTimeField(props) {
    return react_1.default.createElement(instant_field_1.InstantField, { ...props, representation: "local-date-time" });
}
exports.LocalDateTimeField = LocalDateTimeField;
//# sourceMappingURL=local-date-time-field.js.map